import React, {useEffect, useState} from "react";
import moment from "moment";
import "./styles.css";

export default function SentMessagesList(props) {
  return (
    <div className="container">
      <div className="row">
        <div
          className="col container_scroll"
          style={{overflowY: "scroll", height: "100vh"}}
        >
          {props.messages.map((x) => {
            return <IndividualCard data={x} key={x.id} />;
          })}
        </div>
      </div>
    </div>
  );
}

const IndividualCard = (x) => {
  return (
    <div className="card my-4">
      <div className="card-body">
        <div className="d-flex align-items-lg-center justify-content-between">
          <h6>{x.data.msg_reciever.substr(3)}</h6>
          <small className="text-muted" style={{fontSize: "0.9rem"}}>
            {moment(x.data.created_at)
              .add(5, "h")
              .add(30, "m")
              .format("Do MMM YYYY, hh:mm:ss")}
          </small>
        </div>
        <p className="card-text">{x.data.message}</p>
      </div>
    </div>
  );
};
